import React, { Component } from 'react';
import firebase from '../firebase';
import Swal from 'sweetalert2'

class AdoptPokemon extends Component {
    constructor() {
        super();
        this.state = {
            userAdoptedArray: [],
            userName: '',
        }
    }
    //Function filters if the adoption has a duplicate or not. If not, saves the adopted pokemon into the array.
    handleAdopt = (adopted) => {
        if(this.state.userAdoptedArray.includes(adopted)) {
            this.renderDuplicate(adopted);
        } else {
            this.confirmAdopt(adopted);
            this.setState({
                userAdoptedArray: [...this.state.userAdoptedArray, `${this.props.adoptedPokemon}`]
            })
        }
    }
    //Modal that displays the adoption was successful
    confirmAdopt = (name) => {
        return (
            Swal.fire({
                position: 'top',
                type: 'success',
                title: `You adopted ${name}`,
                showConfirmButton: false,
                timer: 1000,
                width: 400,
            })
        )
    }
    //Displays a modal if the selected pokemon was selected twice. 
    renderDuplicate(name) {
        return (
            Swal.fire({
                imageUrl: 'https://media.giphy.com/media/Qv7WFppXtkqkM/giphy.gif',
                imageHeight: 150,
                imageWidth: 200,
                imageAlt: 'The pokemon trainer ash with pikachu in his shoulders',
                html: `You already adopted "${name}". Pick another one`,
            })
        )
    }
    //Deletes the adopted pokemon
    abandonPokemon = (index) => {
        const copiedArray = [...this.state.userAdoptedArray];
        
        const newArray = copiedArray.filter((adopted, i) => {
            return i !== index;
        });

        this.setState({
            userAdoptedArray: newArray
        })
    }
    //Handles if the input was empty or no pokemon adopted
    handleInputErrors = (event) => {
        event.preventDefault();
        if (this.state.userName === "") {
            Swal.fire({
                imageUrl: 'https://media.giphy.com/media/pq2pU6B2Ht3pu/giphy.gif',
                imageHeight: 150,
                imageWidth: 200,
                imageAlt: 'The pokemon trainer ash with pikachu in his shoulders',
                text: `Can't file adoption papers without your name`,
            })
        } else if (this.state.userAdoptedArray.length === 0) {
            Swal.fire({
                imageUrl: 'https://media.giphy.com/media/pq2pU6B2Ht3pu/giphy.gif',
                imageHeight: 150,
                imageWidth: 200,
                imageAlt: 'The pokemon trainer ash with pikachu in his shoulders',
                text: `Can't file adoption papers without adopting atleast one pokemon.`,
            })
        } else {
            Swal.fire({
                title: 'Are you ready to be a guardian?',
                text: "You won't be able to revert this until next update!",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, I want to adopt!'
            }).then((result) => {
                if (result.value) {
                    Swal.fire({
                        imageUrl: 'https://media.giphy.com/media/vmUVgkPoEH14s/giphy.gif',
                        imageHeight: 150,
                        imageWidth: 250,
                        imageAlt: 'The pokemon trainer ash with pikachu in his shoulders',
                        title: 'You are now a Pokemon guardian',
                        text: 'Check the list of guardians below for your name',
                    })
                    this.handleSubmit();
                }
            })
        }
    }
    //Saves selected pokemon to firebase
    handleSubmit = () => {
        const dbRef = firebase.database().ref("Guardians");

        dbRef.push({
            Name: this.state.userName,
            Collection: this.state.userAdoptedArray
        })

        this.setState({
            userName: '',
            userAdoptedArray: []
        })
    };

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    } 
    //Function to display when adoption list is empty
    renderEmpty() {
        return (
            <div className="adoptionEmpty wrapper">
                <p>Please adopt pokemon from list above ...</p>
            </div>
        )
    }
    //Displays the adopted pokemon with their name and image. 
    renderAdoptList() {
        const adoptedList = this.state.userAdoptedArray.map((adopted, i) => {
            return (
                <div key={i} className="pokeTilesContainer">
                    <div
                        className="pokeTiles"
                        value="Open"
                        onClick={() => this.props.selectedPokemonDetails(adopted)}>
                        <p className="pokeName">{adopted}</p>
                        <img className="pokeImage" src={`http://pokestadium.com/sprites/xy/${adopted}.gif`} alt={adopted} />
                    </div>
                    <button className="adoptButton" onClick={() => this.abandonPokemon(i)}>Abandon</button>
                </div>
            )
        });
        return (<div className="displayPokemonContainer">{adoptedList}</div>);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.adoptedPokemon && this.props.adoptedPokemon !== prevProps.adoptedPokemon) {
            this.handleAdopt(this.props.adoptedPokemon);
        }
    }

    render(){
        return(
            <section className="adoptionBackground">
                <div className="wrapper">
                    <div className="adoptContainer">
                        <h2 className="adoptionList">Adoption List</h2>
                        <div>
                            {this.state.userAdoptedArray.length ? this.renderAdoptList() : this.renderEmpty()}  
                        </div>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="adoptionPaperContainer">
                        <h2 className="signUpTitle">Sign Adoption Papers</h2>
                        <form action="">
                            <input
                                name="userName"
                                onChange={this.handleChange}
                                type="text"
                                value={this.state.userName}
                                placeholder="Input your name"
                            />
                        <button onClick={this.handleInputErrors}>File Adoption Papers</button>
                        </form>
                    </div>
                </div>
            </section>
        )
    }
}

export default AdoptPokemon;